module.exports = __webpack_public_path__ + "static/media/Cappella-sistina-volta.eb917491.jpeg";